import type { SDK_StackCfKey } from "../gql/generated/operations";

export const demoStackCfKeys: SDK_StackCfKey[] = [
    {
        __typename: 'StackCfKey',
        created: 0,
        key: 'demo/My-amazing-journey',
        updated: 0
    },
    {
        __typename: 'StackCfKey',
        created: 0,
        key: 'demo/Alone-under-the-stars',
        updated: 0
    },
    {
        __typename: 'StackCfKey',
        created: 0,
        key: 'demo/Walking-with-Sherpas',
        updated: 0
    },
    {
        __typename: 'StackCfKey',
        created: 0,
        key: 'demo/The-business-of-business',
        updated: 0
    },]